import React, { useEffect, useState } from 'react';
import { useAuth } from '../../context';
import Sidebar from '../Sidebar/Sidebar';
import SettingsMenu from '../Settings/SettingsMenu';
import TopBar from './TopBar';
import ZohoStatusBanner from '../ZohoStatusBanner/ZohoStatusBanner';

export default function AppShell({ children, showZohoBanner = false }) {
  const { user, logout } = useAuth();
  const [navigationOpen, setNavigationOpen] = useState(false);
  const [settingsOpen, setSettingsOpen] = useState(false);
  const [collapsed, setCollapsed] = useState(() => localStorage.getItem('sidebar_collapsed') === 'true');
  useEffect(() => { localStorage.setItem('sidebar_collapsed', String(collapsed)); }, [collapsed]);
  useEffect(() => { document.body.classList.toggle('navigation-open', navigationOpen); return () => document.body.classList.remove('navigation-open'); }, [navigationOpen]);
  return <div className={`app-shell ${collapsed ? 'app-shell-collapsed' : ''}`}>
    <Sidebar collapsed={collapsed} open={navigationOpen} onClose={() => setNavigationOpen(false)} onToggleCollapse={() => setCollapsed((value) => !value)} onSettings={() => { setNavigationOpen(false); setSettingsOpen(true); }} logout={logout} clientName={user?.name || 'Team member'} />
    <div className="app-shell-main">
      <TopBar collapsed={collapsed} onOpenNavigation={() => setNavigationOpen(true)} onToggleRail={() => setCollapsed((value) => !value)} />
      <main className="main-content" id="main-content">{showZohoBanner && user?.role === 'admin' && <ZohoStatusBanner />}{children}</main>
    </div>
    <SettingsMenu open={settingsOpen} onOpenChange={setSettingsOpen} showTrigger={false} />
  </div>;
}
